var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "display" },
    [
      _c(
        "v-alert",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          attrs: { color: "primary", value: "true", outline: "" }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("chatWarning")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.onOff,
              expression: "!onOff"
            }
          ],
          attrs: {
            color: "secondary",
            icon: "priority_high",
            value: "true",
            outline: ""
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("chatWarning2")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert,
              expression: "alert"
            }
          ],
          staticClass: "hidden",
          attrs: {
            color: "secondary",
            icon: "warning",
            value: "true",
            outline: ""
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("warningCobrowsingDisabled")) + " "
          ),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertSSL,
              expression: "alertSSL"
            }
          ],
          staticClass: "hidden",
          attrs: {
            color: "warning",
            icon: "priority_high",
            value: "true",
            outline: ""
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("warningCobrowsingHttp")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.loadingGet
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-card",
                { staticClass: "mb-3" },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.onOff ? "CHAT ON" : "CHAT OFF",
                                  light: "",
                                  color: "primary",
                                  disabled: _vm.testBrideStatus(
                                    "parametre_chat"
                                  )
                                },
                                nativeOn: {
                                  click: function($event) {
                                    !_vm.onOff
                                      ? (_vm.warningChatOff = true)
                                      : ""
                                  }
                                },
                                model: {
                                  value: _vm.onOff,
                                  callback: function($$v) {
                                    _vm.onOff = $$v
                                  },
                                  expression: "onOff"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                [
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("announcement")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("autochatTitle")) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("invit.active")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.invit.active
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.invit.active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.$t("autochatTitleLabel"),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.invit.active,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "active", $$v)
                                          },
                                          expression: "invit.active"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.langs,
                                          label: _vm._f("cap")(
                                            _vm.$t("language")
                                          ),
                                          "return-object": "",
                                          dense: "",
                                          disabled: !_vm.invit.active
                                        },
                                        model: {
                                          value: _vm.invit.lang,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "lang", $$v)
                                          },
                                          expression: "invit.lang"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md9: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("content")
                                          ),
                                          required: "",
                                          disabled: !_vm.invit.active
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.updateInvit()
                                          }
                                        },
                                        model: {
                                          value: _vm.invit.content,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "content", $$v)
                                          },
                                          expression: "invit.content"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.invit.active,
                                          expression: "invit.active"
                                        }
                                      ],
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.$t("triggerConditionTime"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-slider", {
                                        attrs: {
                                          "thumb-label": "",
                                          min: 0,
                                          max: 300
                                        },
                                        model: {
                                          value: _vm.invit.delay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "delay", $$v)
                                          },
                                          expression: "invit.delay"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.invit.delay) + " sec."
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.invit.active,
                                          expression: "invit.active"
                                        }
                                      ],
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.$t("triggerConditionUrl"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.$t("restrictFewUrLs"),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.invit.urlonoff,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "urlonoff", $$v)
                                          },
                                          expression: "invit.urlonoff"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.invit.active,
                                          expression: "invit.active"
                                        }
                                      ],
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("containsString"),
                                          disabled: !_vm.invit.urlonoff
                                        },
                                        model: {
                                          value: _vm.invit.url,
                                          callback: function($$v) {
                                            _vm.$set(_vm.invit, "url", $$v)
                                          },
                                          expression: "invit.url"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("assignment")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("prechatTitle")) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("prechat.active")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.prechat.active
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.prechat.active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.$t("prechatTitleLabel"),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.prechat.active,
                                          callback: function($$v) {
                                            _vm.$set(_vm.prechat, "active", $$v)
                                          },
                                          expression: "prechat.active"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md4: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm._f("cap")(_vm.$t("title")),
                                          required: "",
                                          "data-vv-name": "prechat.title",
                                          error: _vm.wzErrors.has(
                                            "prechat.title"
                                          ),
                                          "error-messages": _vm.wzErrors.collect(
                                            "prechat.title"
                                          ),
                                          disabled: !_vm.prechat.active
                                        },
                                        model: {
                                          value: _vm.prechat.title,
                                          callback: function($$v) {
                                            _vm.$set(_vm.prechat, "title", $$v)
                                          },
                                          expression: "prechat.title"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md4: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("subTitle")
                                          ),
                                          disabled: !_vm.prechat.active
                                        },
                                        model: {
                                          value: _vm.prechat.subtitle,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.prechat,
                                              "subtitle",
                                              $$v
                                            )
                                          },
                                          expression: "prechat.subtitle"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md4: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("buttonText")
                                          ),
                                          required: "",
                                          "data-vv-name": "prechat.button",
                                          error: _vm.wzErrors.has(
                                            "prechat.button"
                                          ),
                                          "error-messages": _vm.wzErrors.collect(
                                            "prechat.button"
                                          ),
                                          disabled: !_vm.prechat.active
                                        },
                                        model: {
                                          value: _vm.prechat.button,
                                          callback: function($$v) {
                                            _vm.$set(_vm.prechat, "button", $$v)
                                          },
                                          expression: "prechat.button"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                _vm._l(_vm.itemsFields, function(field, a) {
                                  return _c(
                                    "v-flex",
                                    {
                                      key: a,
                                      attrs: { xs6: "", sm3: "", md2: "" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "primary--text",
                                        attrs: {
                                          disabled: !_vm.prechat.active,
                                          label: field.text,
                                          value: field.value
                                        },
                                        model: {
                                          value: _vm.prechat.fields,
                                          callback: function($$v) {
                                            _vm.$set(_vm.prechat, "fields", $$v)
                                          },
                                          expression: "prechat.fields"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("chat")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("cap")(_vm.$t("firstAutoMessage"))
                              ) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("msgAuto.active")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.msgAuto.active
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.msgAuto.active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.msgAuto.active,
                                          callback: function($$v) {
                                            _vm.$set(_vm.msgAuto, "active", $$v)
                                          },
                                          expression: "msgAuto.active"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm._f("cap")(_vm.$t("title")),
                                          required: "",
                                          "data-vv-name": "msgAuto.content",
                                          error: _vm.wzErrors.has(
                                            "msgAuto.content"
                                          ),
                                          "error-messages": _vm.wzErrors.collect(
                                            "msgAuto.content"
                                          ),
                                          disabled: !_vm.msgAuto.active
                                        },
                                        model: {
                                          value: _vm.msgAuto.content,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.msgAuto,
                                              "content",
                                              $$v
                                            )
                                          },
                                          expression: "msgAuto.content"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("chat")
                          ]),
                          _vm._v(
                            "\n             " +
                              _vm._s(_vm.$t("chatRgpd")) +
                              "\n            "
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("rgpdOnOff")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.rgpdOnOff
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.rgpdOnOff
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.rgpdOnOff,
                                          callback: function($$v) {
                                            _vm.rgpdOnOff = $$v
                                          },
                                          expression: "rgpdOnOff"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-textarea", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("message")
                                          ),
                                          required: "",
                                          counter: 700,
                                          "data-vv-name": "rgpdMsg",
                                          error: _vm.wzErrors.has("rgpdMsg"),
                                          "error-messages": _vm.wzErrors.collect(
                                            "rgpdMsg"
                                          ),
                                          disabled: !_vm.rgpdOnOff
                                        },
                                        model: {
                                          value: _vm.rgpdMsg,
                                          callback: function($$v) {
                                            _vm.rgpdMsg = $$v
                                          },
                                          expression: "rgpdMsg"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "span",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [_vm._v("Exemple ici")]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "En vertu du règlement général de l'UE sur la protection des données (RGPD), nous avons besoin de votre approbation pour notre utilisation des informations personnelles que vous pourriez fournir durant la conversation :\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "(1) Votre IP peut être stockée afin que reprendre la conversation si nous chattons plus tard.\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "(2) Votre e-mail, téléphone ou vos nom/prénom peuvent servir à toutes fins de prospections commerciales.\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "(3)...\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "Pour pouvoir continuer, vous devez accepter ces conditions."
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("question_answer")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("autoResponse"))) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("answerAuto.active")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.answerAuto.active
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.answerAuto.active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.answerAuto.active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.answerAuto,
                                              "active",
                                              $$v
                                            )
                                          },
                                          expression: "answerAuto.active"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.langs,
                                          label: _vm._f("cap")(
                                            _vm.$t("language")
                                          ),
                                          "return-object": "",
                                          disabled: !_vm.answerAuto.active
                                        },
                                        model: {
                                          value: _vm.answerAuto.lang,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.answerAuto,
                                              "lang",
                                              $$v
                                            )
                                          },
                                          expression: "answerAuto.lang"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md9: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("content")
                                          ),
                                          required: "",
                                          disabled: !_vm.answerAuto.active
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.updateMessages()
                                          }
                                        },
                                        model: {
                                          value: _vm.answerAuto.content,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.answerAuto,
                                              "content",
                                              $$v
                                            )
                                          },
                                          expression: "answerAuto.content"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("loyalty")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("leadEditor"))) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("customLead.active")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.customLead.active
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.customLead.active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.customLead.active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.customLead,
                                              "active",
                                              $$v
                                            )
                                          },
                                          expression: "customLead.active"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.customLead.active,
                                          expression: "customLead.active"
                                        }
                                      ],
                                      attrs: { xs12: "", md6: "" }
                                    },
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(_vm.$t("basicFields"))
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.customLeadClassicFields,
                                        function(field, i) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: i,
                                              attrs: { row: "", wrap: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      disabled: !_vm.customLead
                                                        .active,
                                                      label: field.text,
                                                      value: field.value
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customLead.info,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customLead,
                                                          "info",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customLead.info"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      disabled: !_vm.customLead
                                                        .active,
                                                      label: "Obligatoire",
                                                      value: field.value
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customLead
                                                          .info_required,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customLead,
                                                          "info_required",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customLead.info_required"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(
                                              _vm.$t("yourCustomFields")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.customFields, function(field) {
                                        return _c(
                                          "v-layout",
                                          {
                                            key: field.value,
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "primary--text",
                                                  attrs: {
                                                    disabled: !_vm.customLead
                                                      .active,
                                                    label: field.text,
                                                    value: field.value
                                                  },
                                                  model: {
                                                    value: _vm.customLead.info,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.customLead,
                                                        "info",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "customLead.info"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "accent", dark: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.showDialogCreate = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("add")) +
                                              " " +
                                              _vm._s(
                                                _vm.$tc("fields", 1, {
                                                  count: ""
                                                })
                                              ) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("add")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.customLead.active,
                                          expression: "customLead.active"
                                        }
                                      ],
                                      attrs: { xs12: "", md6: "" }
                                    },
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(_vm.$t("basicTags"))
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.customLeadClassicMotifs,
                                        function(field) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: field.value,
                                              attrs: { row: "", wrap: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      disabled: !_vm.customLead
                                                        .active,
                                                      label: field.text,
                                                      value: field.value
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customLead.motifs,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customLead,
                                                          "motifs",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customLead.motifs"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("cap")(
                                              _vm.$t("yourCustomTags")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.customMotifs, function(field) {
                                        return _c(
                                          "v-layout",
                                          {
                                            key: field.value,
                                            attrs: { row: "", wrap: "" }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "primary--text",
                                                  attrs: {
                                                    disabled: !_vm.customLead
                                                      .active,
                                                    label: field.text,
                                                    value: field.value
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.customLead.motifs,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.customLead,
                                                        "motifs",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "customLead.motifs"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "accent", dark: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.showDialogMotif = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("add")) +
                                              " " +
                                              _vm._s(
                                                _vm.$tc("tags", 1, {
                                                  count: ""
                                                })
                                              ) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("add")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("keyboard")
                          ]),
                          _vm._v("\n            IsTyping \n            "),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("isTyping")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.isTyping
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isTyping
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.isTyping,
                                          callback: function($$v) {
                                            _vm.isTyping = $$v
                                          },
                                          expression: "isTyping"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("location_on")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("locationRequest"))) +
                              "\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("ask_geoloc")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.ask_geoloc
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.ask_geoloc
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.$t("locationRequest"),
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.ask_geoloc,
                                  callback: function($$v) {
                                    _vm.ask_geoloc = $$v
                                  },
                                  expression: "ask_geoloc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("extension")
                          ]),
                          _vm._v(
                            "\n            Extension Iframe\n            "
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchValue("extensionEnabled")
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _vm.extensionEnabled
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: { color: "primary", dark: "" }
                                        },
                                        [_vm._v("play_circle_filled")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "infos",
                                          attrs: {
                                            color: "grey primary--text",
                                            dark: ""
                                          }
                                        },
                                        [_vm._v("pause_circle_filled")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.extensionEnabled
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatDeactiv")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatActiv")))
                                  ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("enable")
                                          ),
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.extensionEnabled,
                                          callback: function($$v) {
                                            _vm.extensionEnabled = $$v
                                          },
                                          expression: "extensionEnabled"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "URL",
                                          light: "",
                                          color: "primary",
                                          "persistent-hint": "",
                                          hint: _vm.$t("absiframe1")
                                        },
                                        model: {
                                          value: _vm.extensionUrl,
                                          callback: function($$v) {
                                            _vm.extensionUrl = $$v
                                          },
                                          expression: "extensionUrl"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-subheader", [
                                _vm._v(_vm._s(_vm.$t("absiframe2")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md3: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "accent" },
                                          on: {
                                            click: function($event) {
                                              _vm.extensionUrl +=
                                                "{{visiteurID}}"
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("absiframe3")) +
                                              "\n                    "
                                          ),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("add")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("book_online")
                          ]),
                          _vm._v("Screen Sharing")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.onOffCobrowsing
                                            ? _vm.$t("cobrowsing") + " " + "ON"
                                            : _vm.$t("cobrowsing") +
                                              " " +
                                              "OFF",
                                          light: "",
                                          color: "primary",
                                          hint: _vm.$t("descCobrowsing"),
                                          "persistent-hint": "",
                                          disabled: _vm.testBrideStatus(
                                            "parametre_cobrowsing_cobrowsing"
                                          )
                                        },
                                        model: {
                                          value: _vm.onOffCobrowsing,
                                          callback: function($$v) {
                                            _vm.onOffCobrowsing = $$v
                                          },
                                          expression: "onOffCobrowsing"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.onOffMirroring
                                            ? _vm.$t("mirroring") + " " + "ON"
                                            : _vm.$t("mirroring") + " " + "OFF",
                                          light: "",
                                          color: "primary",
                                          hint: _vm.$t("descMirroring"),
                                          "persistent-hint": "",
                                          disabled: _vm.testBrideStatus(
                                            "parametre_cobrowsing_mirroring"
                                          )
                                        },
                                        model: {
                                          value: _vm.onOffMirroring,
                                          callback: function($$v) {
                                            _vm.onOffMirroring = $$v
                                          },
                                          expression: "onOffMirroring"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        block: _vm.$vuetify.breakpoint.xsOnly,
                        loading: _vm.loadingPost
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.postOptions()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm._f("cap")(_vm.$t("save")))),
                      _c("v-icon", { attrs: { dark: "", right: "" } }, [
                        _vm._v("save")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "290" },
                  model: {
                    value: _vm.showDialogCreate,
                    callback: function($$v) {
                      _vm.showDialogCreate = $$v
                    },
                    expression: "showDialogCreate"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("add")) +
                              "| cap  " +
                              _vm._s(_vm.$tc("fields", 1, { count: "" })) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:32",
                                expression: "'max:32'"
                              }
                            ],
                            attrs: {
                              autofocus: "",
                              required: "",
                              label: _vm._f("cap")(_vm.$t("title")),
                              counter: "",
                              max: "32",
                              "data-vv-name": "newFieldName"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newField,
                              callback: function($$v) {
                                _vm.newField = $$v
                              },
                              expression: "newField"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.showDialogCreate = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.submitDialogCreate.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("submit")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "290" },
                  model: {
                    value: _vm.showDialogMotif,
                    callback: function($$v) {
                      _vm.showDialogMotif = $$v
                    },
                    expression: "showDialogMotif"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("add"))) +
                              " " +
                              _vm._s(_vm.$tc("tags", 1, { count: "" })) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:32",
                                expression: "'max:32'"
                              }
                            ],
                            attrs: {
                              autofocus: "",
                              required: "",
                              label: _vm._f("cap")(_vm.$t("title")),
                              counter: "",
                              max: "32",
                              "data-vv-name": "newFieldName"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogMotif.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newMotif,
                              callback: function($$v) {
                                _vm.newMotif = $$v
                              },
                              expression: "newMotif"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.showDialogMotif = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.submitDialogMotif.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("submit")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "390" },
                  model: {
                    value: _vm.warningChatOff,
                    callback: function($$v) {
                      _vm.warningChatOff = $$v
                    },
                    expression: "warningChatOff"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text" },
                        [
                          _vm._v(
                            "\n            Attention, vous êtes sur le point de couper le chat du côté Visiteur (sur le site web). Les internautes ne pourrons plus discuter avec les téléconseillers (même s'ils sont en ligne) et aucune invitation par chat ne sera envoyée.\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.warningChatOff = false
                                }
                              }
                            },
                            [_vm._v("Continuer")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("wz-dialog-infos", {
                attrs: {
                  titleDialog: _vm.titleDialog,
                  contentDialog: _vm.contentDialog
                },
                on: { fermeDialog: _vm.fermeDialogInfos }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5978ec04", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5978ec04","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Chat.vue
// module id = null
// module chunks = 